import styled from 'styled-components';

const SectionTitle = styled.div.attrs({ className: 'headline6' })`
  color: ${props => props.theme.primary};
`;

export default SectionTitle;